export enum DROPDOWN_ACTIONS {
    SHARE = 'share',
    COPY_LINK = 'copy-link',
    EDIT = 'edit',
    MOVE_TO = 'move-to',
    COPY = 'copy',
    DOWNLOAD = 'download',
    PREPARE_DOWNLOAD = 'prepare-download',
    DELETE = 'delete',
    TRANSLATE = 'translate',
    VIDEO_APPROVAL_STATUS = 'video-approval-status',
    CREATE_SIMILAR = 'create-similar',
    CREATE_BLUEPRINT = 'create-blueprint',
    MANAGE_TAGS = 'manage-tags',
}

export const UNDETERMINED_LANGUAGE = 'und'; // https://iso639-3.sil.org/code/und
